import React, { Component } from 'react';
import styled from '@emotion/styled';

import { Theme } from 'ui_system/theme';
import Modal from 'ui_system/modals/BaseModal';

import { HR } from '../styles';

export const Text = styled.div`
  font-weight: ${(props) => (props.bold ? '600' : '400')};
  color: ${(props) => (props.color ? props.color : Theme.colors.black)};
  font-size: ${(props) => (props.fontSize ? `${props.fontSize}px` : '14px')};

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    font-size: ${(props) =>
      props.mobileFontsize ? `${props.mobileFontsize}px` : 'default'};
  }

  margin-top: ${(props) => (props.marginTop ? `${props.marginTop}px` : '0px')};
  margin-bottom: ${(props) =>
    props.marginBottom ? `${props.marginBottom}px` : '0px'};
  margin-right: ${(props) =>
    props.marginRight ? `${props.marginRight}px` : '0px'};
  margin-left: ${(props) =>
    props.marginLeft ? `${props.marginLeft}px` : '0px'};
`;

const Container = styled.div`
  padding: 30px;
`;

const Section = styled.div`
  margin-top: 15px;
`;

const IconWithText = styled.div`
  display: flex;
  align-items: flex-start;

  i {
    margin-right: 10px;
    color: ${Theme.colors.lightText};
  }

  span {
    font-style: italic;
  }
`;

class BookingModal extends Component {
  renderAddons = (addons) => {
    if (!addons || addons.length === 0) return null;

    const x = <span style={{ color: Theme.colors.lightText }}>x</span>;
    const list = addons.map((addon) => (
      <div>
        {addon.count} {x} {addon.name}
      </div>
    ));

    return (
      <Section>
        <HR />
        <Text color={Theme.colors.lightText}>Add ons</Text>
        {list}
      </Section>
    );
  };

  renderQuestions = (questions) => {
    if (!questions || questions.length === 0) return null;

    const list = questions.map((question) => (
      <div>
        {question.text}: <i>{question.answer}</i>
      </div>
    ));

    return (
      <Section>
        <HR />
        <Text color={Theme.colors.lightText}>Additional Info</Text>
        {list}
      </Section>
    );
  };

  renderGuestNote = (note) => {
    if (!note || note.length === 0) return null;

    return (
      <Section>
        <HR />
        <IconWithText>
          <i className="af-envelope" />
          <span>{note}</span>
        </IconWithText>
      </Section>
    );
  };

  renderPrivateNote = (note) => {
    if (!note || note.length === 0) return null;

    return (
      <Section>
        <HR />
        <IconWithText>
          <i className="af-icon-editnotes" />
          <span>Internal notes: {note}</span>
        </IconWithText>
      </Section>
    );
  };

  render() {
    const { open, close, booking } = this.props;

    let modalBody = null;
    if (booking) {
      const {
        guestName,
        unitsBreakdown,
        addonsBreakdown,
        questionsBreakdown,
        messageFromGuest,
        notes,
      } = booking.attributes;

      modalBody = (
        <Container>
          <Text color={Theme.colors.lightText} marginBottom={5}>
            ID: {booking.id}
          </Text>
          <Text bold fontSize={16} marginBottom={5}>
            {guestName}
          </Text>
          <Text fontSize={14}>{unitsBreakdown}</Text>
          {this.renderAddons(addonsBreakdown)}
          {this.renderQuestions(questionsBreakdown)}
          {this.renderGuestNote(messageFromGuest)}
          {this.renderPrivateNote(notes)}
        </Container>
      );
    }

    return (
      <Modal open={open} close={close}>
        {modalBody}
      </Modal>
    );
  }
}

export default BookingModal;
